module.exports = __webpack_public_path__ + "static/img/icon3.9781352d.png";